import {
  USER_LOGIN_REQ,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILED,
  USER_LOGIN_RESET,
  USER_LOGOUT_REQ,
} from "../Constants/userLoginConstant";
import { REMOVE_LOCAL, SET_LOCAL } from "../Models/LocalData";
import axiosConfig from "../Core/axiosConfig";

export const LOGIN_REQ = (Login_data) => async (dispatch) => {
  try {
    dispatch({ type: USER_LOGIN_REQ });
    let { data } = await axiosConfig.post("/Users/Login", Login_data);

    if (data?.Result.includes("Error")) {
      dispatch({ type: USER_LOGIN_FAILED, payload: data.Result });
    } else {
      SET_LOCAL("login_data", data);
      dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    }
  } catch (ex) {
    dispatch({ type: USER_LOGIN_FAILED, payload: `Error-${ex.message}` });
  }
};

export const Logout = () => async (dispatch) => {
  REMOVE_LOCAL("login_data");
  dispatch({ type: USER_LOGOUT_REQ });
};

export const LOGIN_FORM_RESET = () => (dispatch) => {
  dispatch({ type: USER_LOGIN_RESET });
};
